import { motion } from "framer-motion";
import Reveal, { EASE } from "@/components/Reveal";

const BLOCKS = [
    {
        number: "01",
        overline: "Un progetto comune",
        title: "Un progetto comune",
        text: "GPS srls nasce dall'incontro di professionisti con più di dieci anni di esperienza, che hanno scelto di condividere competenze e visione in un unico progetto al servizio delle imprese e delle persone.",
    },
    {
        number: "02",
        overline: "La bussola",
        title: "Una bussola verso l'obiettivo",
        text: "GPS perché ti portiamo verso il tuo obiettivo. Leggiamo il contesto, tracciamo la rotta e costruiamo con te il percorso più efficace, passo dopo passo.",
    },
    {
        number: "03",
        overline: "Il valore",
        title: "Al centro, il valore",
        text: "Mettiamo al centro il valore, l'ascolto e il supporto: non soluzioni preconfezionate, ma risposte disegnate sulla realtà di ogni cliente, in tutta Italia.",
    },
];

const STATS = [
    { value: "10+", label: "Anni di esperienza", testid: "stat-item-esperienza" },
    { value: "100%", label: "Ascolto e su misura", testid: "stat-item-ascolto" },
    { value: "Italia", label: "Area di intervento", testid: "stat-item-copertura" },
];

export default function ChiSiamo() {
    return (
        <section id="chi-siamo" data-testid="chi-siamo-section" className="bg-[#FAF7F2] py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid items-end gap-12 lg:grid-cols-2">
                    <div>
                        <Reveal>
                            <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#B88282]">Chi siamo</p>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="mt-4 font-serif text-4xl leading-tight tracking-tight sm:text-5xl">
                                Persone, al servizio di <span className="italic text-[#B88282]">persone</span>.
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.15}>
                        <motion.div
                            whileHover={{ scale: 0.985 }}
                            transition={{ duration: 0.6, ease: EASE }}
                            className="overflow-hidden rounded-2xl"
                        >
                            <motion.img
                                initial={{ scale: 1.15 }}
                                whileInView={{ scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 1.4, ease: EASE }}
                                src="https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                                alt="Professionisti GPS srls al lavoro"
                                className="aspect-[16/10] w-full object-cover"
                                loading="lazy"
                            />
                        </motion.div>
                    </Reveal>
                </div>

                <div className="mt-20 grid gap-12 md:grid-cols-3 md:gap-8">
                    {BLOCKS.map((b, i) => (
                        <Reveal key={b.number} delay={0.12 * i}>
                            <div className="group border-t border-[#1A1A1A]/10 pt-8">
                                <span className="text-outline-rose select-none font-serif text-6xl font-bold transition-all duration-500 group-hover:-translate-y-1">
                                    {b.number}
                                </span>
                                <p className="mt-6 text-xs font-medium uppercase tracking-[0.25em] text-[#B88282]">
                                    {b.overline}
                                </p>
                                <h3 className="mt-2 font-serif text-2xl leading-snug">{b.title}</h3>
                                <p className="mt-4 text-sm leading-relaxed text-[#5A5A5A] sm:text-base">{b.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <div
                        data-testid="stats-strip"
                        className="mt-20 grid divide-y divide-[#1A1A1A]/10 border-y border-[#1A1A1A]/10 sm:grid-cols-3 sm:divide-x sm:divide-y-0"
                    >
                        {STATS.map((s) => (
                            <div key={s.testid} data-testid={s.testid} className="px-6 py-10 text-center sm:py-12">
                                <p className="font-serif text-5xl text-[#B88282] sm:text-6xl">{s.value}</p>
                                <p className="mt-3 text-xs uppercase tracking-[0.25em] text-[#5A5A5A]">{s.label}</p>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
